import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatError } from '@angular/material/form-field';
import { Nullable } from 'rt-shared-symbols';
import { FADE_IN_ERROR, FADE_OUT_ERROR } from '../../animations/rt-inputs.animations';

@Component({
  selector: 'rt-inputs-validation',
  templateUrl: './rt-inputs-validation.component.html',
  styleUrls: ['./rt-inputs-validation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatError],
  animations: [
    FADE_IN_ERROR,
    FADE_OUT_ERROR
  ]
})
export class RtInputsValidationComponent {

  /** Relation between the error name imposed by Validators and the error message. */
  @Input() validationMessage: Nullable<string>;

  @Input() shouldIndicateInvalidity: Nullable<boolean> = false;

  @Input() set status(value: Nullable<'VALID' | 'INVALID' | 'DISABLED' | 'PENDING' | string>) {
    this._status = value;
  };

  @Input() set dirty(value: boolean) {
    this._dirty = value;
  };

  private _status: Nullable<'VALID' | 'INVALID' | 'DISABLED' | 'PENDING' | string> = null;
  private _dirty: boolean = false;

  get pending() {
    return this._status === 'PENDING' && this._dirty;
  }
}
